// source: pbtypes/gen/surface_scan/surface_scan_camera_analytics.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_surface_scan_media_capture_mode_pb = require('../../../pbtypes/gen/surface_scan/media_capture_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_media_capture_mode_pb);
var pbtypes_gen_surface_scan_photo_resolution_pb = require('../../../pbtypes/gen/surface_scan/photo_resolution_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_photo_resolution_pb);
var pbtypes_gen_user_camera_sensor_module_pb = require('../../../pbtypes/gen/user_camera/sensor_module_pb.js');
goog.object.extend(proto, pbtypes_gen_user_camera_sensor_module_pb);
goog.exportSymbol('proto.surface_scan.SurfaceScanCameraAnalytics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.surface_scan.SurfaceScanCameraAnalytics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.surface_scan.SurfaceScanCameraAnalytics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.surface_scan.SurfaceScanCameraAnalytics.displayName = 'proto.surface_scan.SurfaceScanCameraAnalytics';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.toObject = function(opt_includeInstance) {
  return proto.surface_scan.SurfaceScanCameraAnalytics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.surface_scan.SurfaceScanCameraAnalytics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanCameraAnalytics.toObject = function(includeInstance, msg) {
  var f, obj = {
isIrEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
resolution: jspb.Message.getFieldWithDefault(msg, 3, 0),
captureMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
primarySensor: jspb.Message.getFieldWithDefault(msg, 5, 0),
gimbalName: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.surface_scan.SurfaceScanCameraAnalytics;
  return proto.surface_scan.SurfaceScanCameraAnalytics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.surface_scan.SurfaceScanCameraAnalytics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsIrEnabled(value);
      break;
    case 3:
      var value = /** @type {!proto.surface_scan.PhotoResolution.Enum} */ (reader.readEnum());
      msg.setResolution(value);
      break;
    case 4:
      var value = /** @type {!proto.surface_scan.MediaCaptureMode.Enum} */ (reader.readEnum());
      msg.setCaptureMode(value);
      break;
    case 5:
      var value = /** @type {!proto.user_camera.SensorModule.Enum} */ (reader.readEnum());
      msg.setPrimarySensor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGimbalName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.surface_scan.SurfaceScanCameraAnalytics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.surface_scan.SurfaceScanCameraAnalytics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanCameraAnalytics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsIrEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getResolution();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCaptureMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPrimarySensor();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getGimbalName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional bool is_ir_enabled = 2;
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.getIsIrEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics} returns this
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.setIsIrEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional PhotoResolution.Enum resolution = 3;
 * @return {!proto.surface_scan.PhotoResolution.Enum}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.getResolution = function() {
  return /** @type {!proto.surface_scan.PhotoResolution.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.surface_scan.PhotoResolution.Enum} value
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics} returns this
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.setResolution = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional MediaCaptureMode.Enum capture_mode = 4;
 * @return {!proto.surface_scan.MediaCaptureMode.Enum}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.getCaptureMode = function() {
  return /** @type {!proto.surface_scan.MediaCaptureMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.surface_scan.MediaCaptureMode.Enum} value
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics} returns this
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.setCaptureMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional user_camera.SensorModule.Enum primary_sensor = 5;
 * @return {!proto.user_camera.SensorModule.Enum}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.getPrimarySensor = function() {
  return /** @type {!proto.user_camera.SensorModule.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.user_camera.SensorModule.Enum} value
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics} returns this
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.setPrimarySensor = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string gimbal_name = 6;
 * @return {string}
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.getGimbalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanCameraAnalytics} returns this
 */
proto.surface_scan.SurfaceScanCameraAnalytics.prototype.setGimbalName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.surface_scan);
